<template>
  <div class="main-index">
    <div class="top">
      <div class="top-hello">
        <!-- <p class="hello-title">Hello,</p>
        <p class="hello-title">欢迎使用~</p> -->
      </div>
      <div class="top-right">
        <!-- <img src="../assets/image/hello_back1.png" alt="" class="right-img" /> -->
      </div>
    </div>
    <div class="bottom" v-if="needLogin && (isActive == 0 || isActive == 1)">
      <p class="loginTitle">
        <span
          class="titem"
          :class="{ active: isActive == 0 }"
          @click="loginTab(0)"
          >密码登录</span
        >
        <span
          class="titem"
          :class="{ active: isActive == 1 }"
          @click="loginTab(1)"
          >验证码登录</span
        >
      </p>
      <div v-if="isActive == 0">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="account">
            <el-input
              class="account"
              placeholder="请输入账号"
              v-model="ruleForm.account"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              class="password"
              placeholder="请输入密码"
              v-model="ruleForm.password"
              :type="showPassword ? 'text' : 'password'"
            >
              <i
                slot="suffix"
                class="el-input__icon"
                :style="{
                  color: showPassword ? '#409eff' : '#c0c4cc',
                  cursor: 'pointer',
                }"
                @click="showPassword = !showPassword"
              >
                {{ showPassword ? "👁️" : "👁️‍🗨️" }}
              </i>
            </el-input>
          </el-form-item>

          <el-button type="primary" class="login" @click="handleLogin"
            >登录</el-button
          >
          <el-button class="register" @click="handleRegister">注册</el-button>
        </el-form>
      </div>
      <div v-if="isActive == 1">
        <el-form
          :model="msgRuleForm"
          :rules="msgRules"
          ref="msgRuleForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="phoneNum">
            <el-input
              v-model="msgRuleForm.phoneNum"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入手机号码"
              autocomplete="off"
              type="text"
              class="phone"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item prop="msgCode">
            <el-row>
              <el-col :span="13"
                ><el-input
                  v-model="msgRuleForm.msgCode"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  placeholder="短信验证码"
                  autocomplete="off"
                  type="text"
                  class="password"
                ></el-input
              ></el-col>
              <el-col :span="10" :offset="1">
                <el-button :disabled="delay != 0" @click="getMsgCode" plain>{{
                  delay == 0 ? "获取验证码" : `${delay}s后获取`
                }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- <div style="margin-bottom: 20px">
            <el-link
              @click="isRegister = true"
              :underline="false"
              type="primary"
              >无账号，去注册？</el-link
            >
          </div> -->
          <el-button type="primary" class="login" @click="handleLoginYzm">{{
            isMsgBtnLoading ? "登录中..." : "登录"
          }}</el-button>
          <el-button class="register" @click="handleRegister">注册</el-button>
          <!-- <el-form-item>
            <el-button
              type="primary"
              @click.native.prevent="submitMsgForm"
              round
              @keyup.enter.native="submitMsgForm"
              :loading="isBtnLoading"
              size="medium"
              class="loginBtn"
              >{{ isMsgBtnLoading ? "登录中..." : "登录" }}</el-button
            >
          </el-form-item> -->
        </el-form>
      </div>
    </div>

    <div class="bottom" v-else-if="isActive == 3">
      <p class="loginTitle">
        <span
          class="titem"
          :class="{ active: isActive == 3 }"
          @click="loginTab(3)"
          >注册</span
        >
      </p>
      <div v-if="isActive == 3">
        <el-form
          :model="msgRuleForm"
          :rules="msgRules"
          ref="msgRuleForm"
          class="demo-ruleForm"
        >
          <el-form-item prop="phoneNum">
            <el-input
              v-model="msgRuleForm.phoneNum"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入手机号码"
              autocomplete="off"
              type="text"
              class="phone"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item prop="msgCode">
            <el-row>
              <el-col :span="13"
                ><el-input
                  v-model="msgRuleForm.msgCode"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  placeholder="短信验证码"
                  autocomplete="off"
                  type="text"
                  class="password"
                ></el-input
              ></el-col>
              <el-col :span="10" :offset="1">
                <el-button :disabled="delay != 0" @click="getMsgCode" plain>{{
                  delay == 0 ? "获取验证码" : `${delay}s后获取`
                }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              class="password"
              placeholder="请输入密码"
              v-model="msgRuleForm.password"
              :type="showPassword ? 'text' : 'password'"
            >
              <i
                slot="suffix"
                class="el-input__icon"
                :style="{
                  color: showPassword ? '#409eff' : '#c0c4cc',
                  cursor: 'pointer',
                  paddingRight: '20px',
                }"
                @click="showPassword = !showPassword"
              >
                {{ showPassword ? "👁️" : "👁️‍🗨️" }}
              </i>
            </el-input>
          </el-form-item>

          <el-button
            class="register"
            type="primary"
            @click="handleNum"
            style="color: white"
            >注册</el-button
          >
          <p
            @click="goDenglu"
            style="
              display: flex;
              justify-content: center;
              cursor: pointer;
              color: #cacbcb;
              margin: 0;
            "
          >
            已有账号，点击登录
          </p>
        </el-form>
      </div>
    </div>
    <div class="bottom" v-else>
      <p class="loginTitle">
        <span
          class="titem"
          :class="{ active: isActive == 2 }"
          @click="loginTab(2)"
          >考生信息登录</span
        >
      </p>
      <div v-if="isActive == 2">
        <el-form
          :model="msgRuleForm"
          :rules="msgRules2"
          ref="msgRuleForm2"
          class="demo-ruleForm"
        >
          <!-- <el-form-item required prop="school">
            <el-select
              v-model="msgRuleForm.school"
              style="width: calc(100% - 40px); margin: 0 20px"
              placeholder="请输入学校名称查找"
              clearable
              filterable
              :filter-method="filterSchools"
              ref="schoolSelect"
              @visible-change="handleSelectFocus"
              @blur="handleFieldBlur('school')"
              no-data-text="请输入学校名称"
              :popper-options="popperOptions"
              :popper-append-to-body="false"
            >
              <template #suffix>
                <i
                  class="el-icon-search"
                  style="color: #c0c4cc; font-size: 14px"
                ></i>
              </template>
              <el-option
                v-for="(item, idx) in filteredSchoolList"
                :key="idx"
                :label="item.label"
                :value="item.value"
                @touchstart.native="handleOptionTouchStart(item.value)"
                @touchend.native="handleOptionTouchEnd"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item required prop="school">
            <div class="custom-select-wrapper">
              <el-select
                v-model="msgRuleForm.school"
                class="custom-search-select"
                style="width: calc(100% - 0px); margin: 0 0px"
                placeholder="请输入学校名称查找"
                clearable
                filterable
                :filter-method="filterSchools"
                ref="schoolSelect"
                @visible-change="handleSelectFocus"
                @blur="handleFieldBlur('school')"
                no-data-text="请输入学校名称"
                :popper-options="popperOptions"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(item, idx) in filteredSchoolList"
                  :key="idx"
                  :label="item.label"
                  :value="item.value"
                  @touchstart.native="handleOptionTouchStart(item.value)"
                  @touchend.native="handleOptionTouchEnd"
                ></el-option>
              </el-select>
              <i class="el-icon-search custom-search-icon"></i>
            </div>
          </el-form-item>

          <!-- <el-form-item prop="name">
            <el-input
              class="login"
              v-model="msgRuleForm.name"
              placeholder="请输入姓名"
              type="text"
            ></el-input>
          </el-form-item> -->
          <el-form-item prop="studyNum">
            <el-input
              class="login"
              v-model="msgRuleForm.studyNum"
              placeholder="请输入学号"
              @blur="handleFieldBlur('studyNum')"
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name">
            <el-input
              class="login"
              v-model="msgRuleForm.name"
              placeholder="请输入姓名"
              @blur="handleFieldBlur('name')"
              type="text"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item prop="studyNum">
            <el-input
              class="login"
              v-model="msgRuleForm.studyNum"
              placeholder="请输入学号"
              type="text"
            ></el-input>
          </el-form-item> -->
          <!-- :disabled="
              !msgRuleForm.school || !msgRuleForm.studyNum || !msgRuleForm.name
            " -->
          <el-button type="primary" class="login" @click="schoolLogin">
            登录
          </el-button>
        </el-form>
      </div>
    </div>
    <el-dialog
      :top="Mobile ? '3vh' : '15vh'"
      v-if="messageVisible"
      :visible.sync="messageVisible"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="350px"
      center
    >
      <template slot="title">
        <div style="display: flex; justify-content: center">
          <div></div>
          <div style="color: black">考试预约</div>
        </div>
      </template>
      <div class="edti-main">
        <el-form
          :model="messageForm"
          :rules="messageRules"
          ref="messageForm"
          label-width="70px"
          @submit.native.prevent
        >
          <div style="display: flex; justify-content: center; font-size: 18px">
            请输入考试信息
          </div>
          <el-form-item
            label="学校："
            prop="studentSchool"
            style="margin-top: 20px"
          >
            <el-select
              v-model="messageForm.studentSchool"
              placeholder="请输入学校名称查找"
              clearable
              filterable
              :filter-method="filterSchools"
              style="width: 100%"
              ref="schoolSelect"
              @visible-change="handleSelectFocus"
              no-data-text="请输入学校名称"
              :popper-options="popperOptions"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, idx) in filteredSchoolList"
                :key="idx"
                :label="item.label"
                :value="item.value"
                @touchstart.native="handleOptionTouchStart(item.value)"
                @touchend.native="handleOptionTouchEnd"
              ></el-option>
              <!-- <el-option
                v-for="(item, idx) in schoolList"
                :key="idx"
                :label="item.label"
                :value="item.value"
              ></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="姓名：" prop="studentName">
            <el-input
              v-model.trim="messageForm.studentName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="学号：" prop="studentNumber">
            <el-input
              v-model.trim="messageForm.studentNumber"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 105px; border-radius: 10px; font-size: 17px"
          size="small"
          @click="confirmLogin"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/libs/api.request";
// import { TOKEN_KEY } from "@/libs/cookieUtil";
// import Cookies from "js-cookie";
export default {
  data() {
    var checkPhoneNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      }
      const reg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (reg.test(value) != true) {
        return callback(new Error("手机号码格式不对，请重新输入"));
      }
      callback();
    };
    return {
      popperOptions: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 10], // 调整偏移量，根据实际情况修改
            },
          },
        ],
      },
      filteredSchoolList: [], // 过滤后的学校列表
      isIOS: false,
      isMobile: true,
      name: "",
      uid: "",
      token: "",
      messageVisible: false,
      hasSchool: false, //账号登录是否有学校和学号
      reservationId: 0,
      isActive: 0,
      showPassword: false,
      needLogin: true,
      ruleForm: {
        account: "", // 添加账号绑定
        password: "",
      }, // 添加密码绑定
      isBtnLoading: false,
      isMsgBtnLoading: false,
      rules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确手机号码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // phoneMsgCode: [{ required: true, message: "短信验证码不能为空" }],
      },
      msgRuleForm: {
        phoneNum: "",
        msgCode: "",
        password: "",
        name: "",
        studyNum: "",
        school: "",
      },
      msgRules: {
        phoneNum: [{ validator: checkPhoneNum, trigger: "change" }],
        msgCode: [
          { required: true, message: "短信验证码不能为空", trigger: "change" },
        ],
        // password: [
        //   { required: true, message: "密码不能为空", trigger: "blur" },
        // ],
        // name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        // school: [{ required: true, message: "学校不能为空", trigger: "blur" }],
        // studyNum: [
        //   { required: true, message: "学号不能为空", trigger: "blur" },
        // ],
      },
      msgRules2: {
        name: [{ required: true, message: "姓名不能为空", trigger: "change" }],
        school: [{ required: true, message: "学校不能为空", trigger: "blur" }],
        studyNum: [
          { required: true, message: "学号不能为空", trigger: "blur" },
        ],
      },
      messageForm: {
        studentSchool: "",
        studentName: "",
        studentNumber: "",
      },
      messageRules: {
        studentName: [
          { required: true, message: "姓名不能为空", trigger: "change" },
        ],
        studentSchool: [
          { required: true, message: "学校不能为空", trigger: "change" },
        ],
        studentNumber: [
          { required: true, message: "学号不能为空", trigger: "change" },
        ],
      },
      schoolList: [],
      delay: 0, // 倒计时时间
      Mobile: false,
    };
  },
  methods: {
    filterSchools(query) {
      // 保存当前输入的值
      const currentInput = query;

      console.log("11", query);

      // 如果查询为空，显示空列表
      if (!query || query.trim() === "") {
        console.log(555);
        this.filteredSchoolList = [];
        return;
      }

      // 使用防抖处理，避免频繁过滤
      if (this.filterTimer) {
        clearTimeout(this.filterTimer);
      }

      this.filterTimer = setTimeout(() => {
        // 筛选出名称包含查询词的学校，同时保留原始数据
        this.filteredSchoolList = this.schoolList.filter(
          (item) =>
            item.value && item.value.toLowerCase().includes(query.toLowerCase())
        );

        // 确保输入框的值不会被清空
        this.$nextTick(() => {
          const input = this.$refs.schoolSelect?.$el?.querySelector("input");
          if (input && input.value !== currentInput) {
            input.value = currentInput;
          }
        });
      }, 100);
    },

    handleNameFocus() {
      if (this.isMobile) {
        this.$nextTick(() => {
          const input = this.$el.querySelector(".login input");
          if (input) {
            input.removeAttribute("readonly"); // 解除只读
            input.setAttribute("data-autofill-disabled", "true");
          }
        });
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    // 添加tab切换方法
    loginTab(index) {
      this.isActive = index;
    },
    handleLogin() {
      axios
        .request({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/v1/login`,
          data: {
            username: this.ruleForm.account,
            password: this.ruleForm.password,
          },
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code === 200) {
            document.onkeydown = undefined;
            let data = ret.data;
            delete data.user.roles;
            if (ret.data.user.number && ret.data.user.school) {
              this.$router.push({
                path: "/order",
                query: {
                  uid: ret.data.user.uid,
                  name: ret.data.user.realName,
                  num: ret.data.user.number,
                  token: ret.data.token,
                  reservationId: this.reservationId,
                  isActive: this.isActive,
                  shareCode: this.$route.query.shareCode,
                  school: ret.data.user.school,
                },
              });
            } else {
              this.name = ret.data.user.realName;
              this.uid = ret.data.user.uid;
              this.token = ret.data.token;
              this.messageVisible = true;
            }

            // if (process.env.NODE_ENV == "development") {
            //   if (window.location.href.startsWith("https")) {
            //     window.location.href =
            //       "https://tfwww.jiudou123.com/admin/class/myClass";
            //     // window.location.href = proLoginLink
            //   } else {
            //     console.log(1);
            //     this.$router.push({
            //       path: "/order",
            //       query: {
            //         uid: ret.data.user.uid,
            //         name: ret.data.user.username,
            //         num: ret.data.user.number,
            //         token: ret.data.token,
            //       },
            //     });
            //   }
            // } else {
            //   console.log(2);
            //   window.location.href = "http://192.168.0.89:8082/#/order";
            //   // "https://www.jiudou123.com/admin/class/myClass";
            // }
          } else {
            this.$message({
              type: "error",
              message: ret.msg,
              offset: 80,
            });
          }
          this.isBtnLoading = false;
        });
    },
    confirmLogin() {
      this.$refs["messageForm"].validate((valid) => {
        if (valid) {
          // if (this.messageForm.studentName != this.name) {
          //   this.$message.warning("姓名不正确，请重新输入");
          //   return;
          // }
          let data = {};
          data.uid = this.uid;
          data.school = this.messageForm.studentSchool;
          data.realName = this.messageForm.studentName;
          data.number = this.messageForm.studentNumber;
          data.token = this.token;
          axios
            .request({
              method: "post",
              url: `${process.env.VUE_APP_BASE_URL}/oauth/v4/user/changeBaseInfoV2`,
              data: data,
            })
            .then((res) => {
              let ret = res.data;
              if (ret.code === 200) {
                this.$router.push({
                  path: "/order",
                  query: {
                    uid: this.uid,
                    name: data.realName,
                    num: data.number,
                    token: this.token,
                    school: data.school,
                    reservationId: this.reservationId,
                    isActive: this.isActive,
                    shareCode: this.$route.query.shareCode,
                  },
                });
              } else {
                this.$message({
                  type: "error",
                  message: ret.msg,
                  offset: 80,
                });
              }
            });
        }
      });
    },
    handleLoginYzm() {
      axios
        .request({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/v1/loginBySms`,
          data: {
            mobile: this.msgRuleForm.phoneNum,
            code: this.msgRuleForm.msgCode,
          },
        })
        .then((res) => {
          let ret = res.data;
          console.log("ret", ret);
          if (ret.code === 200) {
            // this.$router.push({
            //   path: "/order",
            //   query: {
            //     uid: ret.data.info.uid,
            //     name: ret.data.info.realName,
            //     num: ret.data.info.number,
            //     token: ret.data.token,
            //     reservationId: this.reservationId,
            //     isActive: this.isActive,
            //     shareCode: this.$route.query.shareCode,
            //   },
            // });
            if (ret.data.info.number && ret.data.info.school) {
              this.$router.push({
                path: "/order",
                query: {
                  uid: ret.data.info.uid,
                  name: ret.data.info.realName,
                  num: ret.data.info.number,
                  token: ret.data.token,
                  reservationId: this.reservationId,
                  isActive: this.isActive,
                  shareCode: this.$route.query.shareCode,
                  school: ret.data.info.school,
                },
              });
            } else {
              this.name = ret.data.info.realName;
              this.uid = ret.data.info.uid;
              this.token = ret.data.token;
              this.messageVisible = true;
            }
          } else {
            this.$message({
              type: "error",
              message: ret.msg,
              offset: 80,
            });
          }
          this.isBtnLoading = false;
        });
    },
    handleRegister() {
      this.isActive = 3;
      // this.needLogin = false;
    },
    getSchoolList() {
      axios
        .request({
          method: "post",
          url: `${process.env.BASE_URL_V3}/ebook/school/list`, // 这个URL是正确的
          data: {
            pageNo: 1,
            pageSize: 9999,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            // Authorization: "Bearer eac5b233-c21f-4d1e-af30-b1b970b04989",
          },
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code === 200) {
            let school = [];
            ret.data.records.forEach((element) => {
              school.push({
                value: element.name,
              });
            });
            this.schoolList = school;
          }
        })
        .catch(() => {});
    },
    // getSchoolList() {
    //   // 1. 使用封装的request方法
    //   axios
    //     .request({
    //       method: "post",
    //       url: `${process.env.BASE_URL_V3}/ebook/school/list`, // 已自动拼接baseURL
    //       data: {
    //         pageNo: "1",
    //         pageSize: "10",
    //       },
    //       headers: {
    //         "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    //         // Authorization头会自动添加（见拦截器代码）
    //       },
    //     })
    //     .then((res) => {
    //       console.log("响应数据:", res.data);
    //       // 处理学校列表数据
    //     })
    //     .catch((err) => {
    //       console.error("请求失败:", err.response?.data || err.message);
    //     });
    // },
    // getSchoolList() {
    //   axios
    //     .request({
    //       method: "post",
    //       url: `${process.env.VUE_APP_BASE_URL}/ebook/school/list`,
    //       data: {
    //         pageNo: "1",
    //         pageSize: "10",
    //       },
    //       headers: {
    //         "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    //         Authorization: "Bearer 58dfe4f9-cc89-48f6-9a8b-fd10f1594b1a",
    //       },
    //     })
    //     .then(() => {
    //       // 处理响应数据
    //     });
    // },
    // handleSelectFocus(visible) {
    //   if (visible) {
    //     this.filteredSchoolList = []; // 打开下拉时，过滤列表置空
    //     this.$nextTick(() => {
    //       // 获取输入框并添加iOS兼容处理
    //       const input = this.$refs.schoolSelect.$el.querySelector("input");
    //       if (input && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
    //         input.addEventListener("touchstart", this.handleIOSInput, {
    //           once: true,
    //         });
    //       }
    //     });
    //   }
    // },

    handleSelectFocus(visible) {
      if (visible) {
        this.filteredSchoolList = [];
        this.$nextTick(() => {
          const input = this.$refs.schoolSelect.$el.querySelector("input");
          if (input && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
            // 移除原有的事件监听器，避免重复绑定
            input.removeEventListener("touchstart", this.handleIOSInput);
            // 添加新的触摸事件监听器
            input.addEventListener("touchstart", this.handleIOSInput, {
              once: true,
            });

            // 添加点击事件监听器作为备用方案
            input.addEventListener("click", this.handleIOSInput, {
              once: true,
            });
          }
        });
      }
    },

    handleIOSInput(e) {
      // iOS专用处理：短暂聚焦然后重新聚焦以激活键盘
      e.target.blur();
      setTimeout(() => {
        e.target.focus();
      }, 100);
    },
    handleOptionTouchStart(value) {
      if (this.isIOS) {
        // 清除之前的定时器
        clearTimeout(this.touchTimer);

        // 设置新的定时器，模拟点击
        this.touchTimer = setTimeout(() => {
          this.msgRuleForm.school = value;
          this.$forceUpdate();

          // 关闭下拉框
          const select = this.$refs.schoolSelect;
          if (select) {
            select.blur();
            select.visible = false;
          }
        }, 100);
      }
    },

    handleOptionTouchEnd() {
      // 清除定时器，防止重复触发
      clearTimeout(this.touchTimer);
    },
    getMsgCode() {
      this.$refs["msgRuleForm"].validateField("phoneNum", (valid) => {
        if (!valid) {
          if (this.delay == 0) {
            this.delay = 60;
            const interId = setInterval(() => {
              this.delay--;
              if (this.delay == 0) {
                clearInterval(interId);
              }
            }, 1000);
            axios
              .request({
                method: "post",
                url: `${process.env.BASE_URL_V3}/sms/preSmsMsg`,
              })
              .then((res) => {
                let ret = res.data;
                if (ret.code === 200) {
                  this.preMsg = ret.data;
                  let smsCode = this.$md5(this.preMsg.substring(4, 22));
                  axios
                    .request({
                      method: "post",
                      url: `${process.env.BASE_URL_V3}/sms/join`,
                      data: {
                        mobile: this.msgRuleForm.phoneNum,
                        preMsg: this.preMsg,
                        smsCode,
                      },
                    })
                    .then((res) => {
                      let ret = res.data;
                      if (ret.code === 200) {
                        this.$message({
                          type: "success",
                          message: "验证码发送成功",
                        });
                      } else {
                        this.$message({
                          type: "error",
                          message: `${ret.msg}`,
                        });
                      }
                    });
                }
              });
          }
        }
      });
    },
    schoolLogin() {
      // this.$router.push({
      //   path: "/order",
      //   query: {
      //     uid: ret.data.info.uid,
      //   },
      // });
      this.$refs["msgRuleForm2"].validate((valid) => {
        if (valid) {
          let data = {};
          data.school = this.msgRuleForm.school;
          data.stuName = this.msgRuleForm.name;
          data.stuNumber = this.msgRuleForm.studyNum;
          axios
            .request({
              method: "post",
              url: `${process.env.VUE_APP_BASE_URL}/v1/loginByStuNumber`,
              data: data,
            })
            .then((res) => {
              let ret = res.data;
              if (ret.code == 200) {
                console.log("ret", ret.data.info.uid);
                console.log("token", ret.data.token);
                // localStorage.setItem("iframeToken", res.data.token);
                // sessionStorage.setItem("iframeSrc", "true"); // 设置iframe标记

                this.$router.push({
                  path: "/order",
                  query: {
                    uid: ret.data.info.uid,
                    name: ret.data.info.realName,
                    school: ret.data.info.school,
                    num: ret.data.info.number,
                    token: ret.data.token,
                    reservationId: this.reservationId,
                    isActive: this.isActive,
                    shareCode: this.$route.query.shareCode,
                  },
                });
              } else {
                this.$message({
                  message: ret.msg,
                  type: "warning",
                });
              }
            })
            .catch(() => {});
        }
      });
    },
    goDenglu() {
      this.isActive = 0;
      // this.needLogin = true;
    },
    // handleFieldBlur(fieldName) {
    //   // 延迟一下确保元素已经失去焦点
    //   if (fieldName.typeof == "object") {
    //     setTimeout(() => {
    //       this.$refs.msgRuleForm2.validateField(fieldName);
    //     }, 100).catch();
    //   }
    // },
    handleFieldBlur(fieldName) {
      // 延迟确保元素失焦且 DOM 已更新
      setTimeout(() => {
        // 直接验证指定字段（只要传入的 fieldName 是有效字符串，就触发验证）
        if (typeof fieldName === "string" && this.$refs["msgRuleForm2"]) {
          this.$refs["msgRuleForm2"].validateField(fieldName);
        }
      }, 100);
    },
    // 学校选择框的特殊处理

    handleSchoolChange(value) {
      this.msgRuleForm.school = value;
      // 学校选择后立即触发验证
      this.$nextTick(() => {
        this.handleFieldBlur("school");
      });
    },
    handleNum() {
      this.$refs["msgRuleForm"].validate((valid) => {
        if (valid) {
          axios
            .request({
              method: "post",
              url: `${process.env.BASE_URL_V3}/login/register`,
              data: {
                mobile: this.msgRuleForm.phoneNum,
                code: this.msgRuleForm.msgCode,
                password: this.msgRuleForm.password,
              },
            })
            .then((res) => {
              let ret = res.data;
              if (ret.code === 200) {
                this.$message({
                  type: "success",
                  message: `注册成功`,
                  offset: 80,
                });
                this.isActive = 0;
              } else {
                this.$message({
                  type: "error",
                  message: `${ret.msg}`,
                  offset: 80,
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    getExamMessage() {
      axios
        .request({
          method: "post",
          url: `${process.env.BASE_URL_V3}/exam/reservation/queryInfoByCode`,
          data: {
            reservationCode: this.$route.query.shareCode,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            // Authorization头会自动添加（见拦截器代码）
          },
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code === 200) {
            console.log(ret);
            this.needLogin = ret.data.needRegister;
            this.isActive = this.needLogin ? 0 : 2;
            this.reservationId = ret.data.reservationId;
          } else {
            this.$message.warning(ret.msg);
          }
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getExamMessage();
    this.getSchoolList();
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.content =
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      }
    }
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.Mobile = true;
    }
  },
  beforeDestroy() {
    clearTimeout(this.touchTimer);
  },
};
</script>

<style lang="less">
.app-main {
  display: flex;
  justify-content: center;
  height: 100vh;
}
.el-input__inner {
  border-radius: 20px;
  background: #f4f4f4;
}
.el-form-item__error {
  margin-left: 30px;
}
.main-index {
  width: 100%;
  max-width: 400px;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  // background: blue;
  padding: 20px;
  background: url("../assets/image/hello_back2.png") no-repeat;
  background-size: cover; /* 图片覆盖整个div */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 不重复显示 */

  // .backImg {
  //   width: 100%;
  //   padding: 20px;
  //   background: url("../assets/image/hello_back1.png") no-repeat;
  //   background-size: cover; /* 图片覆盖整个div */
  //   background-position: center; /* 图片居中显示 */
  //   background-repeat: no-repeat; /* 不重复显示 */
  // }
  .top {
    height: 30%;
    display: flex;
    justify-items: center;
    align-items: center;
    .top-hello {
      width: 120px;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      padding-left: 10px;
      .hello-title {
        color: #fff;
        font-size: 24px;
      }
    }
    .top-right {
      width: calc(100% - 120px);
      .right-img {
        width: 260px;
        aspect-ratio: 1/1;
      }
    }
  }
  .bottom {
    border-radius: 20px;
    width: calc(100% - 40px);
    height: 400px;
    background: white;

    .loginTitle {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      font-family: "PingFang SC";
      .titem {
        font-weight: 800;
        color: #000000;
        height: 25px;
        font-size: 16px;
        line-height: 25px;
        display: block;
        width: 110px;
        text-align: center;
        padding: 0 5px;
        cursor: pointer;
        &.active {
          color: #0094ff;
          border-bottom: 2px solid #0094ff;
        }
      }
    }
    .account {
      padding: 0px 0px 0 20px;
      margin-top: 20px;
      border-radius: 50px;
      width: calc(100% - 40px);
    }
    .password {
      padding: 0 0px 0px 20px;
      border-radius: 50px;
      width: calc(100% - 40px);
    }
    .login {
      margin: 20px 20px 0 20px;
      width: calc(100% - 40px);
      border-radius: 20px;
    }
    .register {
      border: 1px solid #0094ff;
      color: #0094ff;
      margin: 10px 20px;
      width: calc(100% - 40px);
      border-radius: 20px;
    }
    .phone {
      padding: 20px 20px 0 20px;
      width: calc(100% - 40px);
    }
  }
}

@media (max-width: 768px) {
  .main-index {
    max-width: 100%; /* 手机端占满宽度 */
  }
}
.custom-check-icon {
  display: none !important;
}

::v-deep .el-select-dropdown {
  height: 200px; /* 固定高度，内容超出可能被截断 */
  overflow-y: auto; /* 强制显示滚动条 */
}

/* 强制隐藏默认箭头并显示放大镜 */
::v-deep .el-select .el-input__suffix {
  display: flex !important;
  align-items: center !important;
}

::v-deep .el-select .el-input__suffix-inner {
  display: flex !important;
  align-items: center !important;
}

::v-deep .el-select .el-select__caret {
  display: none !important;
}

::v-deep .el-select .el-icon-search {
  display: block !important;
  font-size: 16px !important;
  color: #c0c4cc !important;
  margin-right: 8px !important;
}

::v-deep
  .el-select
  .el-input__suffix
  .el-input__suffix-inner
  i:not(.el-icon-search) {
  display: none !important;
}

.custom-select-wrapper {
  position: relative;
  width: calc(100% - 40px);
  margin: 0 20px;
}

.custom-search-select .el-input__suffix {
  display: none !important;
}

.custom-search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #c0c4cc;
  z-index: 10;
  pointer-events: none;
}
</style>